module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURQBQ10dwTABS2QBS2QBQ0wBQ2ABQ1wBS2QBS1wBR2gBQ2QBR2QBS3gBS2HnMaCQAAAAOdFJOU2AA3/kQNCCvgMJQmB9wzkL1xgAAAFdJREFUCNdjEIQDBlSmI5zpaRQIZToUrVZgYGBgATKTzAWMlJSUdEAKgic3wtSKdQkKisANEzUuAWsD6mHaqg3WBtSjzFisA1Uga2kGt40jkCzbsDgdCgCDbBi4ZCkzzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxpclit2.png
// module id = YFd4
// module chunks = 1